module.exports = __webpack_public_path__ + "img/中国石油大学.0dc2b1b1.png";